import React, { useState, useRef, useEffect } from 'react';
import '../certificate.css';
import 'bootstrap/dist/css/bootstrap.css';
import { Row } from 'react-bootstrap';
import Template3Overlay from './Template3Overlay';
import Template4Overlay from './Template4Overlay';
import Template2Overlay from './Template2Overlay';
import Template5Overlay from './Template5Overlay';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Define PrintContent component
const PrintContent = ({
  imageUrl,
  formation_header,
  nom,
  CIN,
  formation,
  date,
  publicKey,
  status,
  componentRef,
}) => {
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!userInfo || !(userInfo.isAdmin || userInfo.isOffice)) {
      navigate('/login');
    }
  }, [navigate, userInfo]);

  return (
    <div className='middle-side' ref={componentRef}>
      <div className='template-preview'>
        {imageUrl && (
          <div className='image-container'>
            <img src={imageUrl} alt='Middle Side' className='img-fluid' />
            {imageUrl === 'maitre.jpg' && (
              <Template2Overlay
                nom={nom}
                CIN={CIN}
                formation={formation}
                date={date}
                publicKey={publicKey}
                status={status}
              />
            )}
            {imageUrl === 'pnl.jpg' && (
              <Template3Overlay
                formation_header={formation_header}
                nom={nom}
                CIN={CIN}
                formation={formation}
                date={date}
                publicKey={publicKey}
                status={status}
              />
            )}
            {imageUrl === 'Coach.jpg' && (
              <Template4Overlay
                nom={nom}
                CIN={CIN}
                formation={formation}
                date={date}
                publicKey={publicKey}
                status={status}
              />
            )}
            {imageUrl === 'formateur.jpg' && (
              <Template5Overlay
                nom={nom}
                CIN={CIN}
                formation={formation}
                date={date}
                publicKey={publicKey}
                status={status}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

function CertificateGenerator() {
  const [imageUrl, setImageUrl] = useState('');
  const [formation_header, setFormationHeader] = useState('');
  const [nom, setNom] = useState('');
  const [CIN, setCIN] = useState('');
  const [formation, setFormation] = useState('');
  const [date, setDate] = useState('');
  const [publicKey, setPublicKey] = useState('');
  const [status, setStatus] = useState('');
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));

  const componentRef = useRef(null);

  const handleFormationHeaderChange = (event) => {
    setFormationHeader(event.target.value);
  };

  const handleNomChange = (event) => {
    setNom(event.target.value);
  };

  const handleCINChange = (event) => {
    setCIN(event.target.value);
  };

  const handleFormationChange = (event) => {
    setFormation(event.target.value);
  };

  const handleDateChange = (event) => {
    setDate(event.target.value);
  };

  // Function to handle printing that preserves CSS
  const handlePrint = () => {
    if (!componentRef.current) {
      toast.error('Print component not ready');
      return;
    }

    // Create a new window for printing
    const printWindow = window.open('', '', 'height=600,width=800');

    if (!printWindow) {
      toast.error('Popup blocked. Please allow popups for printing.');
      return;
    }

    // Get your existing CSS
    const allCSS = Array.from(document.styleSheets)
      .map((styleSheet) => {
        try {
          return Array.from(styleSheet.cssRules)
            .map((rule) => rule.cssText)
            .join('\n');
        } catch (e) {
          console.log('Error accessing styleSheet', e);
          return '';
        }
      })
      .join('\n');

    // Get the content to print
    const contentToPrint = componentRef.current.outerHTML;

    // Write to the new window
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Print Certificate</title>
          <style>${allCSS}</style>
          <style>
            /* Additional Print-specific styles */
            body {
              margin: 0;
              padding: 0;
              overflow: hidden;
            }
            
            @media print {
              @page {
                size: A4 landscape;
                margin: 0;
              }
              
              .middle-side {
                width: 100% !important;
                height: 100vh !important;
                overflow: hidden;
              }
              
              /* Hide any unwanted elements for printing */
              body > *:not(.middle-side) {
                display: none !important;
              }
            }
          </style>
        </head>
        <body class="print-certificate">
          ${contentToPrint}
          <script>
            // Automatically trigger print after loading
            window.onload = function() {
              setTimeout(() => {
                window.print();
                window.onafterprint = function() {
                  window.close();
                };
              }, 500);
            };
          </script>
        </body>
      </html>
    `);

    printWindow.document.close();
  };

  const templateUrls = ['maitre.jpg', 'pnl.jpg', 'Coach.jpg', 'formateur.jpg'];

  const apiUrl = '/api/certificates';

  const saveCertificate = () => {
    if (imageUrl && formation_header && nom && CIN && formation && date) {
      const certificateData = {
        imageUrl,
        formation_header,
        nom,
        CIN,
        formation,
        date,
      };

      fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`,
        },
        body: JSON.stringify(certificateData),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('Certificate saved:', data);
          const { publicKey } = data.createdCertificate;
          setPublicKey(publicKey);
          const { status } = data.createdCertificate;
          setStatus(status);
          toast.success('Certificate saved');
        })
        .catch((error) => {
          console.error('Error saving certificate:', error);
          toast.error('Error saving certificate');
        });
    } else {
      toast.warning('Please fill all fields and select a template');
    }
  };

  return (
    <Row style={{ display: 'flex' }} className='roww'>
      <div className='col-2 left-side'>
        <h2>Choose Your Template</h2>
        <br />
        <div
          className='templates'
          style={{ maxHeight: '500px', overflow: 'auto' }}
        >
          {templateUrls.map((templateUrl, index) => (
            <div key={index}>
              <img
                src={templateUrl}
                alt={`Template ${index + 1}`}
                className={`img-fluid template-image ${
                  imageUrl === templateUrl ? 'selected' : ''
                }`}
                onClick={() => setImageUrl(templateUrl)}
                style={{ marginBottom: '50px' }}
              />
            </div>
          ))}
        </div>
      </div>
      <PrintContent
        componentRef={componentRef}
        imageUrl={imageUrl}
        formation_header={formation_header}
        nom={nom}
        CIN={CIN}
        formation={formation}
        date={date}
        publicKey={publicKey}
        status={status}
      />
      <div className='col-3 right-side'>
        <div className='logo'>
          <h6>Header</h6>
          <input
            type='text'
            value={formation_header}
            onChange={handleFormationHeaderChange}
            className='form-control'
            placeholder='Header'
          />

          <h6>Nom & Prénom</h6>
          <input
            type='text'
            value={nom}
            onChange={handleNomChange}
            className='form-control'
            placeholder='Nom & Prénom'
          />
          <h6>CIN</h6>
          <input
            type='text'
            value={CIN}
            onChange={handleCINChange}
            className='form-control'
            placeholder='CIN'
          />
          <h6>Formation</h6>
          <input
            type='text'
            value={formation}
            onChange={handleFormationChange}
            className='form-control'
            placeholder='Formation'
          />
          <h6>Date De livraison Du Diplome</h6>
          <input
            type='date'
            value={date}
            onChange={handleDateChange}
            className='form-control'
            placeholder='Date'
          />
          <br />
          <button onClick={saveCertificate} className='btn btn-primary'>
            Save Certificate
          </button>
          <button onClick={handlePrint} className='btn btn-secondary'>
            Print
          </button>
        </div>
      </div>
    </Row>
  );
}

export default CertificateGenerator;
